<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <template v-if="$permission.canWrite()">
          <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
          <el-button type="danger" @click="delRows">删除</el-button>
        </template>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="180">
          <template slot-scope="{row}">
            <el-button type="text" @click="editById(row.ExamId)" v-if="$permission.canWrite()">编辑</el-button>
            <el-button type="text" @click="detailsById(row.ExamId)" v-else>查看</el-button>
            <el-button type="text" @click="pickCardPrint(row)">打印点名卡</el-button>
            <el-button type="text" @click="stickerPrint(row.ExamId)">打印桌贴</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <view-dialog ref="viewDialog" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/po/exam/list";
import editDialog from "@/components/po/exam/editDialog";
import viewDialog from "@/components/po/exam/viewDialog";

export default {
  name: "poexam",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    viewDialog
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    detailsById(id) {
      this.$refs.viewDialog.openDetailsById(id);  
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.ExamId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    stickerPrint(id) {
      let newpage = this.$router.resolve({
        path: '/stickerPrint?id=' + id
      })
      window.open(newpage.href, '_blank'); 
    },
    pickCardPrint(row) {
      var path = '/pickCard?id=';
      if(row.StudentNumber > 42 && row.StudentNumber <= 48) path = '/pickCard2?id=';
      let newpage = this.$router.resolve({
        path: path + row.ExamId + "&type=" + row.EnrollType
      })
      window.open(newpage.href, '_blank'); 
    },
  }
};
</script>